import { Directive } from '@angular/core';

@Directive({
    selector: '[pItemListHeaderDef]',
})
export class ItemListHeaderDefDirective {}
